import { Link } from 'react-router-dom';
import { Facebook, Instagram, MapPin, Mail, Phone } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        {/* Mobile Logo - Only visible on mobile */}
        <div className="md:hidden mb-1">
          <div className="flex flex-col items-center space-y-6">
            <img
              src="/images/logos/omac_white_sm.png"
              alt="OMAC-UK Logo"
              className="w-[14.4rem] h-auto"
            />
            <div className="w-full">
              <h3 className="font-display text-xl font-bold flex items-center">
                <span className="text-taekwondo-red">OMAC-UK</span>
                <span className="ml-2">Taekwondo</span>
              </h3>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="space-y-4">
            {/* Desktop Logo and Title - Only visible on desktop */}
            <div className="hidden md:block">
              <div className="flex flex-col space-y-4">
                <img
                  src="/images/logos/omac_white_sm.png"
                  alt="OMAC-UK Logo"
                  className="w-[14.4rem] h-auto"
                />
                <h3 className="font-display text-xl font-bold flex items-center mb-2">
                  <span className="text-taekwondo-red">OMAC-UK</span>
                  <span className="ml-2">Taekwondo</span>
                </h3>
              </div>
            </div>
            <p className="text-gray-300 text-sm">
              Providing quality Taekwondo training in Gedling, Nottingham since 2003.
              We welcome students of all ages and abilities.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="font-display text-lg font-semibold">Quick Links</h3>
            <ul className="flex flex-wrap md:flex-col gap-2 md:space-y-2">
              <li><Link to="/" className="text-gray-300 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-white transition-colors">About</Link></li>
              <li><Link to="/history" className="text-gray-300 hover:text-white transition-colors">History</Link></li>
              <li><Link to="/team" className="text-gray-300 hover:text-white transition-colors">Team</Link></li>
              <li><Link to="/schedule" className="text-gray-300 hover:text-white transition-colors">Schedule</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="font-display text-lg font-semibold">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="shrink-0 text-taekwondo-red" />
                <span className="text-gray-300">1st Floor, 65 Gedling Road, Corner of Westdale Lane East, Gedling, Nottingham, NG4 3FG</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={20} className="shrink-0 text-taekwondo-red" />
                <a href="tel:01159874857" className="text-gray-300 hover:text-white transition-colors" rel="noopener">0115 987 4857</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={20} className="shrink-0 text-taekwondo-red" />
                <a href="mailto:masterjuliet@omac-uk.co.uk" className="text-gray-300 hover:text-white transition-colors">masterjuliet@omac-uk.co.uk</a>
              </li>
              <li className="flex flex-col space-y-2 pt-3">
                <h3 className="font-display text-lg font-semibold">Social Media</h3>
                <div className="flex space-x-4">
                  <a href="https://facebook.com" className="text-taekwondo-red hover:text-white transition-colors" aria-label="Facebook">
                    <Facebook size={20} />
                  </a>
                  <a href="https://instagram.com" className="text-taekwondo-red hover:text-white transition-colors" aria-label="Instagram">
                    <Instagram size={20} />
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            &copy; {currentYear} OMAC-UK Taekwondo. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <ul className="flex space-x-6 text-sm text-gray-400">
              <li>
                <Link to="/privacy-policy" className="hover:text-white transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}
